import React from "react";
import { injectIntl, FormattedMessage } from "react-intl";
import { compose } from "recompose";
import { connect } from "react-redux";
import { logoutSubmit, changeUserInfo } from "modules/login/login";
import { changeAlways } from "modules/membership/join";
import styled from "styled-components";
import { Link, withRouter } from "react-router-dom";
import ImgLogo from "images/logo.png";

const Gnb = styled.nav`
  height: 140px;

  .inr {
    position: relative;
  }
`;

const LinkLogo = styled(Link)`
  display: block;
  position: absolute;
  top: 45px;
  left: 0;
  height: 37px;
`;

const Logo = styled.div`
  position: absolute;
  left: 0;
  width: 133px;
  height: 37px;
  vertical-align: top;
`;

const H1 = styled.h1`
  margin-top: 17px;
  padding-left: 150px;
  color: #02348b;
  font-size: 20px;
  font-weight: bold;
  white-space: pre-line;
`;

const NavWrap = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

const GnbUl = styled.ul`
  display: flex;
  justify-content: flex-end;

  &:after {
    display: block;
    clear: both;
    content: "";
  }
`;

const GnbLi = styled.li`
  float: left;
  margin-left: 15px;
`;

const SnbUl = styled.ul`
  display: flex;
  justify-content: flex-end;
  margin: 23px 20px 15px 0;

  &:after {
    display: block;
    clear: both;
    content: "";
  }
`;

const SnbLi = styled.li`
  float: left;
  margin-left: 20px;
  color: #969696;
  cursor: pointer;

  a {
    color: #969696;
  }
  &.default {
    cursor: default;
  }
  &.join {
    padding-right: 20px;
    border-right: 1px solid #d9d9d9;
  }
`;

const StyledLink = styled(Link)`
  display: block;
  padding: 10px 20px;
  font-size: 18px;
  white-space: pre-line;

  &:hover,
  &.on {
    border-radius: 3px;
    background: #118ccf;
    color: #fff;
  }
`;

const NavGnb = ({
  urlData,
  navName,
  gnbActive,
  changeAlways,
  loginData,
  logoutSubmit,
  changeUserInfo,
  history,
  location
}) => {
  const locale = localStorage.getItem("ctcrLocale");
  const authorization = localStorage.getItem("ctcrAuth");

  const onLogout = async () => {
    await logoutSubmit();

    // redux에 로그인정보 삭제
    await changeUserInfo(null);

    // localStorage에 로그인정보 삭제
    localStorage.removeItem("ctcrAuth");

    // 홈 화면으로 이동
    history.push(`${location.pathname}`);

    // reload
    // window.location.reload();
  };

  const onChangeAlways = () => {
    // 일반 회원가입은 always 빈값
    changeAlways("");
  };

  return (
    <Gnb className="gnb">
      <div className="inr">
        <LinkLogo to={`/${locale}/main`}>
          <Logo>
            <img src={ImgLogo} alt="logo" />
          </Logo>
          <H1>
            <FormattedMessage id={"main.logo"} />
          </H1>
        </LinkLogo>
        <NavWrap>
          <SnbUl>
            {!authorization ? (
              <>
                <SnbLi>
                  <Link to={`/${locale}/login`}>
                    <FormattedMessage id={"login.buttonTxt"} />
                  </Link>
                </SnbLi>
                <SnbLi className="join">
                  <Link
                    to={`/${locale}/membership/join`}
                    onClick={onChangeAlways}
                  >
                    <FormattedMessage id={"login.signIn"} />
                  </Link>
                </SnbLi>
              </>
            ) : (
              <>
                <SnbLi className="default">
                  {loginData && loginData.username}
                  {(locale === "kr" || locale === "jp") && (
                    <FormattedMessage id={"login.user"} />
                  )}
                </SnbLi>
                <SnbLi>
                  <Link to={`/${locale}/myinfo/userInfo`}>
                    <FormattedMessage id={"login.mypage"} />
                  </Link>
                </SnbLi>
                <SnbLi className="join">
                  <span onClick={onLogout}>
                    <FormattedMessage id={"login.logout"} />
                  </span>
                </SnbLi>
              </>
            )}
            {locale !== "en" && (
              <SnbLi>
                <a href="/en/main">ENGLISH</a>
              </SnbLi>
            )}
            {locale !== "kr" && (
              <SnbLi>
                <a href="/kr/main">한국어</a>
              </SnbLi>
            )}
            {locale !== "jp" && (
              <SnbLi>
                <a href="/jp/main">日本語</a>
              </SnbLi>
            )}
            {locale !== "cn" && (
              <SnbLi>
                <a href="/cn/main">中國語</a>
              </SnbLi>
            )}
          </SnbUl>
          <GnbUl>
            {urlData.map(item => (
              <GnbLi key={item.id}>
                <StyledLink
                  to={item.url}
                  className={navName(item.url) === gnbActive ? "on" : ""}
                >
                  {item.name}
                </StyledLink>
              </GnbLi>
            ))}
          </GnbUl>
        </NavWrap>
      </div>
    </Gnb>
  );
};

const enhance = compose(withRouter, injectIntl);

export default connect(({ login }) => ({ loginData: login.loginData }), {
  logoutSubmit,
  changeUserInfo,
  changeAlways
})(enhance(NavGnb));
